module.exports = __webpack_public_path__ + "static/img/full-bear.6a87b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/onboarding/views/invite/images/animation/full-bear.png
// module id = F/k2
// module chunks = 12